import {AnyAction, Middleware} from '@reduxjs/toolkit'
import {getLogger} from '../../services/logging'

const logger = getLogger('actionHistoryMiddleware')
const MAX_ACTION_HISTORY = 10

let actionHistory: AnyAction[] = []

/**
 * Middleware to log last N actions dispatched to the store.
 * @param storeApi The redux store API
 * @returns
 */
export const actionHistoryMiddleware: Middleware = _storeApi => next => action => {
  try {
    const result = next(action)

    actionHistory.push(action)
    if (actionHistory.length > MAX_ACTION_HISTORY) {
      actionHistory.shift()
    }

    return result
  } catch (e) {
    logger.error({
      message: 'Error in action logger middleware',
      errorData: {
        error: e.message
      }
    })
  }
}

export function getActionHistory(): AnyAction[] {
  return [...actionHistory]
}
